import React from "react";
import {
  FaHtml5,
  FaCss3Alt,
  FaJsSquare,
  FaReact,
  FaGit,
  FaGithub,
  FaCode,
} from "react-icons/fa";

import {
  SiSass,
  SiTypescript,
  SiNextdotjs,
  SiBootstrap,
  SiTailwindcss,
  SiNpm,
  SiVite,
} from "react-icons/si";


const Skills = () => {
  const isDarkMode = document.body.classList.contains("dark");

  return (
<div
  className={`min-h-screen flex flex-col justify-start items-center p-8 ${
    isDarkMode ? "bg-[#111827] text-white" : "bg-white text-gray-900"
  }`}
  style={{ overflow: "hidden" }}
>


      {/* Heading */}
      <h1 className="text-5xl font-bold mb-12">Skills</h1>

      {/* Description Text */}
      <p className="text-lg font-medium text-center mb-12 leading-relaxed">
        I am a Front-End Developer with strong foundations in modern web
        technologies. I have hands-on experience building responsive and scalable
        user interfaces using HTML, CSS, Sass, JavaScript, TypeScript, React,
        Next.js, Bootstrap, and Tailwind CSS.
      </p>

      {/* Skills Sections */}
      <div className="grid grid-cols-1 gap-12 md:grid-cols-2 xl:grid-cols-3 max-w-5xl w-full">
        {/* Languages & Databases */}
          <div className="text-center">
          <h2 className="text-2xl font-semibold mb-4">Core Technologies</h2>
          <div className="flex justify-center  flex-wrap gap-6 text-7xl">
          <FaHtml5 className="text-[#E34F26]"  title="HTML5" />
          <FaCss3Alt className="text-[#1572B6]" title="CSS3" />
          <SiSass className="text-[#CC6699]" title="Sass" />
          <FaJsSquare className="text-[#F7DF1E]" title="JavaScript" />
          <SiTypescript className="text-[#3178C6]" title="TypeScript" />
        </div>

        </div>

        {/* Frameworks & Technologies */}
        <div className="text-center">
          <h2 className="text-2xl font-semibold mb-4">Frameworks & Libraries</h2>
          <div className="flex justify-center flex-wrap gap-6 text-7xl">
          <FaReact className="text-[#61DAFB]" title="React" />
          <SiNextdotjs className="text-black" title="Next.js" />
          <SiBootstrap className="text-[#7952B3]" title="Bootstrap" />
          <SiTailwindcss className="text-[#38BDF8]" title="Tailwind CSS" />
        </div>

        </div>

        {/* Tools & Platforms */}
        <div className="text-center">
        <h2 className="text-2xl font-semibold mb-4">Tools</h2>
        <div className="flex justify-center flex-wrap gap-6 text-7xl">
        <FaGit className="text-[#F1502F]" title="Git" />
        <FaGithub className="text-black" title="GitHub" />
        <FaCode className="text-[#007ACC]" title="VS Code" />
        <SiNpm className="text-[#CB3837]" title="npm" />
        <SiVite className="text-[#646CFF]" title="Vite" />
      </div>

        </div>

        {/* Development Tools */}
        {/* <div className="text-center">
          <h2 className="text-2xl font-semibold mb-4">Development Tools</h2>
          <div className="flex justify-center space-x-6">
            <div className="flex flex-col items-center text-5xl">
              <FaCode className="text-[#007ACC]" title="Visual Studio Code" />
              <span className="text-sm mt-1">VS Code</span>
            </div>
            <div className="flex flex-col items-center text-5xl">
              <SiPycharm className="text-[#00C853]" title="PyCharm" />
              <span className="text-sm mt-1">PyCharm</span>
            </div>
          </div>
        </div> */}
      </div>
    </div>
    
  );
};

export default Skills;
